import {
    IAlterarUsuarioResponsavelRequest,
    IConcluirAtividadeRequest,
    IInserirHistoricoRequest,
    IListarCasoRequest,
    IListarCasoResponse,
    IListarEtapasResponse,
    IListarHistoricoResponse,
    IPesoAtendimento
} from "../../../Interfaces/Vendas/Caso/CasoInterface";
import AxiosVendas from "../../Config/ApiVendas";
import Service from "../../Service";

export async function ListarCasosVendasService<
    TResponseType extends Array<IListarCasoResponse> | Blob
>(requestBody: IListarCasoRequest, exportExcel?: boolean) {
    return Service(
        AxiosVendas.post<TResponseType>(
            `/app/caso/listarcasos?exportExcel=${exportExcel}`,
            requestBody,
            { responseType: exportExcel ? "blob" : "json" }
        )
    );
}

export async function ListarEtapasVendasService() {
    return Service(
        AxiosVendas.get<Array<IListarEtapasResponse>>(`/app/caso/listaretapas`)
    );
}

export async function AvancarEtapaVendasService(
    idCaso: number,
    idEtapa: number,
    idFilaAtendimento?: number
) {
    return Service(
        AxiosVendas.put(
            `/app/caso/avancaretapa?idCaso=${idCaso}&idEtapa=${idEtapa}&idFilaAtendimento=${
                idFilaAtendimento ? idFilaAtendimento : 0
            }`
        )
    );
}

export async function VoltarEtapaVendasService(
    idCaso: number,
    idEtapa: number,
    dsComentario: number
) {
    return Service(
        AxiosVendas.put(
            `/app/caso/voltaretapa?idCaso=${idCaso}&idEtapa=${idEtapa}&dsComentario=${dsComentario}`
        )
    );
}

export async function ListarHistoricoVendasService(idCaso: number) {
    return Service(
        AxiosVendas.get<Array<IListarHistoricoResponse>>(
            `/app/caso/listarhistorico?idCaso=${idCaso}`
        )
    );
}

export async function InserirHistoricoVendasService(
    requestBody: IInserirHistoricoRequest
) {
    return Service(AxiosVendas.post(`/app/caso/inserirhistorico`, requestBody));
}

export async function ListarAtributosObrigatoriosVendasService(idCaso: number) {
    return Service(
        AxiosVendas.post(
            `/app/caso/listaratributosobrigatorios?idCaso=${idCaso}`
        )
    );
}

export async function ConcluirAtividadeVendasService(
    requestBody: Array<IConcluirAtividadeRequest>
) {
    return Service(
        AxiosVendas.post(`/app/caso/concluiratividade`, requestBody)
    );
}

export async function AlterarUsuarioResponsavelVendasService(
    requestBody: IAlterarUsuarioResponsavelRequest
) {
    return Service(
        AxiosVendas.post(`/app/caso/alterarusuarioresponsavel`, requestBody)
    );
}

export async function ListarPesoAtendimentoService() {
    return Service(
        AxiosVendas.get<Array<IPesoAtendimento>>(
            `/app/caso/listarpesosatendimentos`
        )
    );
}
